import { render, staticRenderFns } from "./ContainerScrolling.vue?vue&type=template&id=a2aeabda"
import script from "./ContainerScrolling.vue?vue&type=script&lang=js"
export * from "./ContainerScrolling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports